const Property_Input_Widget_Button_Property_Manipulation = function (opts) {
    // this.input_type = 'charcoal/admin/property/input/widgetbutton';
    Charcoal.Admin.Property.call(this, opts)

    this.input_id = '';
    this.property = null;
    this.manipulations = [];

    this.set_properties(opts)

    this.element().on('click', (event) => this.handleManipulations(event))
};

Property_Input_Widget_Button_Property_Manipulation.prototype = Object.create(Charcoal.Admin.Property.prototype);
Property_Input_Widget_Button_Property_Manipulation.prototype.constructor = Property_Input_Widget_Button_Property_Manipulation;
Property_Input_Widget_Button_Property_Manipulation.prototype.parent = Charcoal.Admin.Property.prototype;

Property_Input_Widget_Button_Property_Manipulation.prototype.set_properties = function (opts) {
    this.input_id = opts.id || this.input_id;
    this.property = opts.data.property || this.property;
    this.manipulations = opts.data.manipulations || this.manipulations;

    return this;
};

Property_Input_Widget_Button_Property_Manipulation.prototype.handleManipulations = function (event) {
   this.manipulations.map((manipulation) => {
        const manip = new Manipulation(manipulation)
       manip.execute();
    })
};

class Manipulation {
    source;
    target;
    action;

    constructor(data) {
        for (const item in data) {
            this[item] = data[item];
        }
    }

    execute() {
        if (this.action && this[this.action]) {
            this[this.action]()
        }
    }

    copy() {
        if (!this.target || !this.source) {
            throw new Error('Cannot copy, missing source or target');
        }

        const copyData = $(`[name=${this.source}]`).val()
        $(`[name=${this.target}]`).val(copyData).trigger('change')
    }
}

Charcoal.Admin.Property_Input_Widget_Button_Property_Manipulation = Property_Input_Widget_Button_Property_Manipulation;
